'use strict';

import { Report } from './QAReport';
import { projectMode } from '../../settings';

export class QAAirMode extends Report{
	constructor () {
		super('AirMode');
	}
	
	validate() {
		if (this.jsonReport.length) {
			this.showReport();
			return;
		}
		
		const configLoaded = projectMode.AirMode.isConfigLoaded;
		const devices = projectMode.AirMode.params.devices;
		const hasPanoramas = Object.keys(projectMode.AirMode.params.panoramas).length;
		const dayAndNight = projectMode.AirMode.hasDayAndNight();
		const skyMask = projectMode.AirMode.hasSkyMask();
		
		this.jsonReport.push(`Config file is downloaded: ${configLoaded}`);
		this.jsonReport.push(`Device support: ${devices.join(',')}`);
		this.jsonReport.push(`Number of panoramas: ${hasPanoramas}`);
		this.jsonReport.push(`Has night panorama: ${dayAndNight}`);
		this.jsonReport.push(`Has sky mask texture: ${skyMask}`);
		
		this.showReport();
	}
	
}
